import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSession } from "@/lib/auth/client";

/**
 * Protected-route wrapper (TW-3431). Every route except /login is mounted under this:
 * while the session resolves we show nothing; with no session we redirect to /login
 * (remembering where the user was headed); otherwise we render the protected tree.
 */
export function RequireAuth({ children }: { children: ReactNode }) {
  const { data: session, isPending } = useSession();
  const location = useLocation();

  if (isPending) {
    // Brief, unstyled hold while the session cookie is verified — avoids a login flash.
    return <div className="muted" style={{ padding: "12vh 24px", textAlign: "center" }} />;
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
}
